import { Box, Divider, Skeleton } from "@mui/material";
import { ratingDetailsStyles } from "./styles";

const RatingDetailsLoader = () => {
  return (
    <Box sx={ratingDetailsStyles.container}>
      {Array.from({ length: 5 }).map((_, index) => (
        <Box key={index} sx={ratingDetailsStyles.reviewMeterContainer}>
          <Box sx={ratingDetailsStyles.starsContainer}>
            <Box sx={ratingDetailsStyles.starIcons}>
              {Array.from({ length: 5 }).map((_, starIndex) => (
                <Skeleton key={starIndex} variant="circular" width={16} height={16} sx={{ marginRight: "2px" }} />
              ))}
            </Box>
            <Skeleton variant="text" width={40} height={20} />
          </Box>

          <Box sx={ratingDetailsStyles.progressContainer}>
            <Skeleton variant="rectangular" width={338} height={8} sx={{ borderRadius: 0 }} />
            <Skeleton variant="text" width={45} height={20} />
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default RatingDetailsLoader;
